/* Product page behavior: gallery, the layered "Build your Strolee" preview, options, add-ons, sticky Add to cart, back-in-stock. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function fill(template, map) {
    return String(template || '').replace(/\{(\w+)\}/g, function (match, key) { return map[key] !== undefined ? map[key] : match; });
  }

  /* ---------- layered preview ----------
     One picture made of stacked images: the cart in the chosen color, plus one transparent image for each
     added accessory. Every layer has the same size and camera angle, so nothing is positioned by script. */
  function Stage(box) {
    this.box = box;
    this.base = qs('.stage__layer--base', box);
    this.sizes = this.base ? this.base.getAttribute('sizes') : '';
    this.layers = {};
  }
  Stage.prototype.apply = function (img, layer) {
    if (img.getAttribute('data-src') === layer.src) return;
    img.setAttribute('data-src', layer.src);
    if (layer.srcset) img.setAttribute('srcset', layer.srcset); else img.removeAttribute('srcset');
    img.setAttribute('src', layer.src);
  };
  Stage.prototype.setBase = function (layer) {
    if (this.base && layer && layer.src) this.apply(this.base, layer);
  };
  Stage.prototype.set = function (key, layer, order) {
    if (!layer || !layer.src) { this.remove(key); return; }
    var img = this.layers[key];
    if (!img) {
      img = document.createElement('img');
      img.className = 'stage__layer';
      img.alt = '';
      img.setAttribute('decoding', 'async');
      if (this.sizes) img.setAttribute('sizes', this.sizes);
      img.style.zIndex = String(1 + order);
      img.addEventListener('load', function () { img.classList.add('is-visible'); });
      this.box.appendChild(img);
      this.layers[key] = img;
    }
    this.apply(img, layer);
    if (img.complete && img.naturalWidth) img.classList.add('is-visible');
  };
  Stage.prototype.remove = function (key) {
    var img = this.layers[key];
    if (!img) return;
    delete this.layers[key];
    img.classList.remove('is-visible');
    window.setTimeout(function () { if (img.parentNode) img.parentNode.removeChild(img); }, reduceMotion ? 0 : 450);
  };

  /* ---------- gallery ---------- */
  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = qs('[data-track]', this);
        this.slides = qsa('[data-slide]', this);
        this.thumbs = qsa('[data-thumb]', this);
        this.prev = qs('[data-prev]', this);
        this.next = qs('[data-next]', this);
        this.current = qs('[data-current]', this);
        this.index = 0;
        if (!this.track || !this.slides.length) return;

        var ticking = false;
        this.track.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () { ticking = false; self.sync(); });
        }, { passive: true });

        this.thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () { self.goToMedia(thumb.getAttribute('data-thumb')); });
        });
        if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1); });
        if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });
        this.track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight') { event.preventDefault(); self.go(self.index + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); self.go(self.index - 1); }
        });

        this.addEventListener('click', function (event) {
          var zoom = event.target.closest('[data-zoom]');
          var box = qs('[data-lightbox]');
          if (!zoom || !box || !box.showModal) return;
          event.preventDefault();
          qs('[data-lightbox-img]', box).src = zoom.getAttribute('href');
          box.showModal();
        });

        var box = qs('[data-lightbox]');
        if (box && !box.hasAttribute('data-bound')) {
          box.setAttribute('data-bound', '');
          box.addEventListener('click', function (event) {
            if (event.target.closest('[data-lightbox-close]') || event.target === box) box.close();
          });
        }
        this.sync();
      }

      go(index) {
        var i = Math.max(0, Math.min(this.slides.length - 1, index));
        var slide = this.slides[i];
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }

      goToMedia(id) {
        for (var i = 0; i < this.slides.length; i++) {
          if (this.slides[i].getAttribute('data-media-id') === String(id)) { this.go(i); return; }
        }
      }

      /* The layered preview, when the page has one, is always the first item. */
      hasStage() { return !!qs('.gallery__slide--stage', this); }
      showStage() { if (this.hasStage()) this.goToMedia('stage'); }
      setStageThumb(layer) {
        var img = qs('.gallery__thumb--stage img', this);
        if (!img || !layer || !layer.src) return;
        var small = layer.srcset ? layer.srcset.split(',')[0].replace(/^\s+/, '').split(' ')[0] : layer.src;
        img.removeAttribute('srcset');
        img.setAttribute('src', small);
      }

      sync() {
        var width = this.track.clientWidth || 1;
        var i = Math.round(this.track.scrollLeft / width);
        i = Math.max(0, Math.min(this.slides.length - 1, i));
        if (i !== this.index) {
          qsa('video', this.slides[this.index]).forEach(function (v) { v.pause(); });
        }
        this.index = i;
        var id = this.slides[i].getAttribute('data-media-id');
        this.thumbs.forEach(function (thumb) {
          if (thumb.getAttribute('data-thumb') === id) {
            thumb.setAttribute('aria-current', 'true');
            if (thumb.scrollIntoView && thumb.parentNode.parentNode.scrollWidth > thumb.parentNode.parentNode.clientWidth) {
              var list = thumb.parentNode.parentNode;
              list.scrollTo({ left: thumb.parentNode.offsetLeft - list.clientWidth / 2 + 40, behavior: reduceMotion ? 'auto' : 'smooth' });
            }
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
        if (this.current) this.current.textContent = i + 1;
        if (this.prev) this.prev.disabled = i === 0;
        if (this.next) this.next.disabled = i === this.slides.length - 1;
      }
    });
  }

  /* ---------- product form ---------- */
  if (!customElements.get('product-form')) {
    customElements.define('product-form', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var S = window.Strolee;
        this.form = document.getElementById(this.getAttribute('data-form'));
        this.variants = [];
        try { this.variants = JSON.parse(qs('[data-variants]', this).textContent); } catch (e) { this.variants = []; }
        this.idInput = this.form ? qs('[data-variant-id]', this.form) : null;
        this.variant = this.findById(this.idInput ? this.idInput.value : null) || this.variants[0];
        this.gallery = qs('product-gallery', this);
        this.sticky = qs('[data-sticky-atc]', this.parentNode.parentNode) || qs('[data-sticky-atc]');

        var colorFieldset = qs('fieldset.option--color', this);
        this.colorIndex = colorFieldset ? parseInt(colorFieldset.getAttribute('data-option-index'), 10) : -1;

        /* Build your Strolee: accessories, what is selected, and the layered pictures. */
        this.addonsRoot = qs('[data-addons]', this);
        this.addons = [];
        if (this.addonsRoot) {
          try { this.addons = JSON.parse(qs('[data-addons-data]', this.addonsRoot).textContent); } catch (e) { this.addons = []; }
        }
        this.selected = [];
        this.stages = qsa('[data-stage-box]', this).map(function (box) { return new Stage(box); });

        this.addEventListener('change', function (event) {
          var target = event.target;
          if (target.matches('.option__input')) { self.onOptionChange(target); return; }
          if (target.matches('input[name="quantity"]')) { self.totals(); }
        });

        this.addEventListener('click', function (event) {
          var toggle = event.target.closest('[data-addon-toggle]');
          if (toggle) { self.toggleAddon(toggle); return; }
          var more = event.target.closest('[data-addons-more]');
          if (more) {
            qsa('.addon--extra', self).forEach(function (el) { el.hidden = false; });
            more.setAttribute('aria-expanded', 'true');
            more.hidden = true;
            var first = qs('.addon--extra [data-addon-toggle]', self);
            if (first) first.focus();
            return;
          }
          var bis = event.target.closest('[data-bis-submit]');
          if (bis) self.onBackInStock(bis);
        });

        if (this.form) {
          this.form.addEventListener('submit', function (event) {
            if (!S || !S.Cart) return;
            event.preventDefault();
            self.submit();
          });
        }

        this.observeSticky();
        this.refreshAddons(false);
        this.renderBuild(false);
      }

      findById(id) {
        for (var i = 0; i < this.variants.length; i++) { if (String(this.variants[i].id) === String(id)) return this.variants[i]; }
        return null;
      }

      findAddon(id) {
        for (var i = 0; i < this.addons.length; i++) { if (String(this.addons[i].id) === String(id)) return this.addons[i]; }
        return null;
      }

      isSelected(id) { return this.selected.indexOf(String(id)) > -1; }

      currentColor() {
        if (this.colorIndex < 0 || !this.variant || !this.variant.options) return null;
        return this.variant.options[this.colorIndex];
      }

      selectedOptions() {
        return qsa('fieldset.option', this).map(function (fieldset) {
          var checked = qs('.option__input:checked', fieldset);
          return checked ? checked.value : null;
        });
      }

      onOptionChange(input) {
        var options = this.selectedOptions();
        var changedIndex = parseInt(input.closest('fieldset').getAttribute('data-option-index'), 10);
        var match = null;
        var fallback = null;
        this.variants.forEach(function (v) {
          var same = v.options.every(function (value, i) { return value === options[i]; });
          if (same) match = v;
          if (!fallback && v.options[changedIndex] === options[changedIndex] && v.available) fallback = v;
        });
        var variant = match || fallback;
        if (!variant) return;
        if (!match) {
          qsa('fieldset.option', this).forEach(function (fieldset, i) {
            qsa('.option__input', fieldset).forEach(function (radio) { radio.checked = radio.value === variant.options[i]; });
          });
        }
        this.setVariant(variant);
      }

      atcLabel() {
        var strings = (window.theme && window.theme.strings) || {};
        if (!this.variant || !this.variant.available) return strings.soldOut;
        return this.variant.state === 'preorder' ? strings.preorder : strings.addToCart;
      }

      setVariant(variant) {
        var strings = (window.theme && window.theme.strings) || {};
        this.variant = variant;

        qsa('[data-variant-id], [data-installment-id]', this).forEach(function (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        var price = qs('[data-price-slot]', this);
        if (price) price.innerHTML = variant.priceHtml;
        var ship = qs('[data-ship-slot]', this);
        if (ship) ship.innerHTML = variant.line;

        var prop = qs('[data-ship-property]', this);
        if (prop) { prop.value = variant.date; prop.disabled = variant.state !== 'preorder'; }

        var scope = this.parentNode.parentNode;

        qsa('fieldset.option', this).forEach(function (fieldset, i) {
          var out = qs('[data-option-value]', fieldset);
          if (out) out.textContent = variant.options[i];
        });

        var stickyPrice = qs('[data-sticky-price]', scope);
        if (stickyPrice) stickyPrice.textContent = variant.money;
        var stickyShip = qs('[data-sticky-ship]', scope);
        if (stickyShip) stickyShip.textContent = variant.state === 'preorder' ? ' · ' + (strings.shipProperty || 'Ships') + ' ' + variant.date : '';

        var bis = qs('[data-bis]', this);
        if (bis) bis.hidden = variant.available;

        var galleryBadge = qs('[data-gallery-badge]', scope);
        if (galleryBadge && typeof variant.badge === 'string') galleryBadge.innerHTML = variant.badge;

        /* The shipping promise in the trust stack follows the selected color: its own ship date, the in-stock line, or nothing when sold out. */
        var trustShip = qs('[data-trust-ship]', scope);
        if (trustShip) {
          var trustTitle = qs('[data-trust-ship-title]', trustShip);
          var trustText = qs('[data-trust-ship-text]', trustShip);
          trustShip.hidden = !variant.available;
          trustShip.setAttribute('data-state', variant.state);
          if (trustText && variant.available) {
            trustText.textContent = variant.state === 'preorder' ? (trustShip.getAttribute('data-preorder-text') || '') : (trustShip.getAttribute('data-instock-text') || '');
          }
          if (trustTitle && variant.available) {
            trustTitle.textContent = variant.state === 'preorder' ? (strings.shipProperty || 'Ships') + ' ' + variant.date : trustShip.getAttribute('data-instock');
          }
        }

        /* Picture: with the layered preview, the cart changes color in place. Otherwise the gallery moves to that color's photo. */
        if (this.gallery && this.gallery.hasStage && this.gallery.hasStage()) {
          if (variant.layer) {
            this.stages.forEach(function (stage) { stage.setBase(variant.layer); });
            this.gallery.setStageThumb(variant.layer);
          }
          this.gallery.showStage();
        } else if (this.gallery && variant.media && this.gallery.goToMedia) {
          this.gallery.goToMedia(variant.media);
        }

        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url.toString());
        }

        this.refreshAddons(true);
        this.renderBuild(false);
      }

      /* ---------- Build your Strolee ---------- */

      /* Which variant of an accessory goes with the cart as it is now.
         Accessories that come in colors must match the cart color exactly. If that color is not offered, it cannot be added. */
      resolveAddon(addon) {
        var color = this.currentColor();
        var variants = addon.variants || [];
        var firstAvailable = null;
        var i;
        for (i = 0; i < variants.length; i++) { if (variants[i].available) { firstAvailable = variants[i]; break; } }
        if (addon.colorIndex < 0 || color === null) {
          return { variant: firstAvailable || variants[0] || null, matched: !!firstAvailable };
        }
        for (i = 0; i < variants.length; i++) {
          if (variants[i].color === color && variants[i].available) return { variant: variants[i], matched: true };
        }
        return { variant: null, matched: false };
      }

      /* Bring every accessory card in line with the selected cart color. */
      refreshAddons(announceDrops) {
        if (!this.addonsRoot) return;
        var self = this;
        var root = this.addonsRoot;
        var color = this.currentColor();
        var dropped = [];
        this.addons.forEach(function (addon) {
          var row = qs('[data-addon="' + addon.id + '"]', root);
          if (!row) return;
          var button = qs('[data-addon-toggle]', row);
          var result = self.resolveAddon(addon);
          var shown = result.variant || addon.variants[0];
          var note = qs('[data-addon-note]', row);

          var price = qs('[data-addon-price]', row);
          if (price && shown) price.textContent = shown.money;
          var variantText = qs('[data-addon-variant]', row);
          if (variantText) variantText.textContent = (!addon.single && result.variant) ? ' · ' + result.variant.title : '';
          var shipText = qs('[data-addon-ship]', row);
          if (shipText) shipText.textContent = (result.variant && addon.available && result.variant.state === 'preorder') ? ' · ' + fill(root.getAttribute('data-ships'), { date: result.variant.date }) : '';

          if (!button) return;
          var label = qs('[data-addon-label]', button);
          if (!result.matched) {
            if (self.isSelected(addon.id)) {
              self.selected.splice(self.selected.indexOf(String(addon.id)), 1);
              dropped.push(addon);
              if (note) { note.textContent = fill(root.getAttribute('data-dropped'), { color: color }); note.hidden = false; }
            }
            button.setAttribute('aria-disabled', 'true');
            button.setAttribute('aria-pressed', 'false');
            if (label) label.textContent = color ? fill(root.getAttribute('data-color-unavailable'), { color: color }) : root.getAttribute('data-color-unavailable-short');
            row.classList.remove('is-selected');
          } else {
            var on = self.isSelected(addon.id);
            button.removeAttribute('aria-disabled');
            button.setAttribute('aria-pressed', on ? 'true' : 'false');
            if (label) label.textContent = on ? root.getAttribute('data-added') : root.getAttribute('data-add');
            row.classList.toggle('is-selected', on);
            if (note && !note.hidden) { note.hidden = true; note.textContent = ''; }
          }
        });
        if (announceDrops && dropped.length && window.Strolee) {
          window.Strolee.announce(dropped.map(function (a) { return a.title; }).join(', ') + '. ' + fill(root.getAttribute('data-dropped'), { color: color }), true);
        }
      }

      toggleAddon(button) {
        var row = button.closest('[data-addon]');
        var addon = row ? this.findAddon(row.getAttribute('data-addon')) : null;
        if (!addon || button.getAttribute('aria-disabled') === 'true') return;
        var result = this.resolveAddon(addon);
        if (!result.matched || !result.variant) return;
        var key = String(addon.id);
        var adding = !this.isSelected(key);
        if (adding) this.selected.push(key); else this.selected.splice(this.selected.indexOf(key), 1);
        this.refreshAddons(false);
        this.renderBuild(true);
        if (window.Strolee && this.addonsRoot) {
          window.Strolee.announce(fill(this.addonsRoot.getAttribute(adding ? 'data-announce-added' : 'data-announce-removed'), { title: addon.title, total: this.totalText || '' }), true);
        }
      }

      /* Draw the build: accessory layers on every preview, the preview's description, and the totals. */
      renderBuild(userChange) {
        var self = this;
        var names = [];
        this.addons.forEach(function (addon) {
          var on = self.isSelected(addon.id);
          var result = on ? self.resolveAddon(addon) : null;
          var layer = (on && result.variant && addon.hero !== false) ? result.variant.layer : null;
          if (on) names.push(addon.title);
          self.stages.forEach(function (stage) { stage.set(String(addon.id), layer, addon.order); });
        });

        if (this.addonsRoot) {
          var root = this.addonsRoot;
          var color = this.currentColor();
          var label = color ? fill(root.getAttribute('data-preview-color'), { color: color }) : root.getAttribute('data-preview');
          if (names.length) label += fill(root.getAttribute('data-preview-with'), { items: names.join(', ') });
          var main = this.gallery ? qs('[data-stage-box]', this.gallery) : null;
          if (main && label) main.setAttribute('aria-label', label);

          var miniText = qs('[data-build-mini-text]', root);
          if (miniText) {
            var count = names.length === 0 ? root.getAttribute('data-count-none') : (names.length === 1 ? root.getAttribute('data-count-one') : fill(root.getAttribute('data-count-other'), { count: names.length }));
            miniText.textContent = (color ? color + ' · ' : '') + count;
          }
        }

        if (userChange && this.gallery && this.gallery.showStage) this.gallery.showStage();
        this.totals();
      }

      totals() {
        if (!this.variant) return;
        var self = this;
        var S = window.Strolee;
        var money = function (cents) { return S ? S.formatMoney(cents) : ''; };
        var qtyInput = this.form ? qs('input[name="quantity"]', this.form) : null;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var total = this.variant.price * qty;
        var lines = [];
        var color = this.currentColor();
        var root = this.addonsRoot;
        /* Special offer: cents off each cart (an automatic discount in Shopify), shown as its own row. */
        var promo = parseInt(this.getAttribute('data-promo') || '0', 10) || 0;
        if (promo >= this.variant.price) promo = 0;
        total -= promo * qty;
        var promoRow = root ? qs('[data-addons-promo-amount]', root) : null;
        if (promoRow && promo > 0) promoRow.textContent = '\u2212' + money(promo * qty);

        /* Build your Strolee & save: tiers (percent off per accessory count) from the block settings.
           Only items in the discount's collections count, mirroring Shopify's automatic discounts. */
        var tiers = root && root.getAttribute('data-tiers') ? root.getAttribute('data-tiers').split(',').map(function (t) { return parseInt(t, 10) || 0; }) : [];
        var baseDiscountable = root && root.getAttribute('data-base-discountable') === 'true';
        var discountableCount = 0;
        var discountableSum = baseDiscountable ? this.variant.price * qty : 0;

        this.selected.forEach(function (id) {
          var addon = self.findAddon(id);
          var result = addon ? self.resolveAddon(addon) : null;
          if (!result || !result.variant) return;
          total += result.variant.price;
          if (addon.discountable) { discountableCount += 1; discountableSum += result.variant.price; }
          var meta = [];
          if (!addon.single) meta.push(result.variant.title);
          if (result.variant.state === 'preorder' && root) meta.push(fill(root.getAttribute('data-ships'), { date: result.variant.date }));
          lines.push({ title: addon.title, meta: meta.join(' · '), price: '+' + money(result.variant.price) });
        });

        var tier = tiers.length ? Math.min(discountableCount, tiers.length) : 0;
        var pct = tier > 0 ? tiers[tier - 1] : 0;
        var savings = pct > 0 ? Math.round(discountableSum * pct / 100) : 0;
        this.totalText = money(total - savings);
        this.updateSavings(tiers, tier, pct, savings, money);

        var label = this.atcLabel();
        var scope = this.parentNode.parentNode;
        qsa('[data-atc], [data-atc-sticky], [data-atc-secondary]', scope).forEach(function (button) {
          button.disabled = !self.variant.available;
          var text = qs('[data-atc-label]', button);
          if (text) text.textContent = label;
        });
        var summary = root ? qs('[data-addons-summary]', root) : null;
        var always = !!(summary && summary.hasAttribute('data-always'));
        /* The builder's own button always carries the total; the plain button shows it once something was added. */
        var showTotal = (always || lines.length > 0 || qty > 1) && this.variant.available;
        qsa('[data-atc-total]', this).forEach(function (el) { el.textContent = showTotal ? ' · ' + self.totalText : ''; });

        if (!root) return;
        var miniTotal = qs('[data-build-mini-total]', root);
        if (miniTotal) miniTotal.textContent = this.totalText;

        if (!summary) return;
        summary.hidden = lines.length === 0 && !always;
        var empty = qs('[data-addons-empty]', summary);
        if (empty) empty.hidden = lines.length > 0;
        var totalsBox = qs('[data-addons-totals]', summary);
        if (totalsBox) totalsBox.hidden = lines.length === 0 && qty === 1 && promo === 0;
        var list = qs('[data-addons-lines]', summary);
        if (list) {
          while (list.firstChild) list.removeChild(list.firstChild);
          var baseMeta = [];
          if (color) baseMeta.push(color);
          if (qty > 1) baseMeta.push('× ' + qty);
          if (this.variant.state === 'preorder') baseMeta.push(fill(root.getAttribute('data-ships'), { date: this.variant.date }));
          [{ title: root.getAttribute('data-base-title'), meta: baseMeta.join(' · '), price: money(this.variant.price * qty) }].concat(lines).forEach(function (line) {
            var li = document.createElement('li');
            li.className = 'addons__line';
            var name = document.createElement('span');
            var title = document.createElement('span');
            title.className = 'addons__line-title';
            title.textContent = line.title;
            name.appendChild(title);
            if (line.meta) {
              var small = document.createElement('span');
              small.className = 'addons__line-meta';
              small.textContent = line.meta;
              name.appendChild(small);
            }
            var price = document.createElement('span');
            price.className = 'addons__line-price';
            price.textContent = line.price;
            li.appendChild(name);
            li.appendChild(price);
            list.appendChild(li);
          });
        }
        var out = qs('[data-addons-total]', summary);
        if (out) out.textContent = this.totalText;
      }

      /* Moves the savings line along and words the message: unlock the first tier, the next tier, or the best deal. */
      updateSavings(tiers, tier, pct, savings, money) {
        var root = this.addonsRoot;
        if (!root || !tiers.length) return;
        qsa('[data-savings-step]', root).forEach(function (step) {
          var n = parseInt(step.getAttribute('data-savings-step'), 10);
          step.classList.toggle('is-reached', n <= tier);
          step.classList.toggle('is-next', n === tier + 1);
        });
        var track = qs('[data-savings]', root);
        if (track) track.style.setProperty('--progress', tiers.length > 1 ? (tier / (tiers.length - 1) * 100) + '%' : '0%');
        var message;
        if (tier === 0) message = fill(root.getAttribute('data-savings-start'), { pct: tiers[0] });
        else if (tier < tiers.length) message = fill(root.getAttribute('data-savings-next'), { pct: pct, next: tiers[tier] });
        else message = fill(root.getAttribute('data-savings-max'), { pct: pct });
        qsa('[data-savings-msg]', root).forEach(function (msg) { msg.textContent = message; });
        var line = qs('[data-addons-savings]', root);
        if (line) {
          line.hidden = savings <= 0;
          var label = qs('[data-addons-savings-label]', line);
          var amount = qs('[data-addons-savings-amount]', line);
          if (label) label.textContent = fill(root.getAttribute('data-savings-line'), { pct: pct });
          if (amount) amount.textContent = '\u2212' + money(savings);
        }
        var note = qs('[data-addons-savings-note]', root);
        if (note) note.hidden = savings <= 0;
      }

      submit() {
        var self = this;
        var S = window.Strolee;
        var strings = window.theme.strings;
        var scope = this.parentNode.parentNode;
        var buttons = qsa('[data-atc], [data-atc-sticky], [data-atc-secondary]', scope);
        var errorBox = qs('[data-form-error]', this);
        var qtyInput = qs('input[name="quantity"]', this.form);
        var main = { id: this.variant.id, quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1 };
        if (this.variant.state === 'preorder' && this.variant.date) {
          main.properties = {};
          main.properties[strings.shipProperty] = this.variant.date;
        }
        var items = [main];
        this.selected.forEach(function (id) {
          var addon = self.findAddon(id);
          var result = addon ? self.resolveAddon(addon) : null;
          if (!result || !result.variant) return;
          var item = { id: result.variant.id, quantity: 1 };
          if (result.variant.state === 'preorder' && result.variant.date) {
            item.properties = {};
            item.properties[strings.shipProperty] = result.variant.date;
          }
          items.push(item);
        });

        if (this.busy) return;
        this.busy = true;
        buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
        if (errorBox) errorBox.hidden = true;

        S.Cart.add(items).then(function () {
          self.busy = false;
          buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
          /* Start the next build from a clean cart picture, so a second tap never adds the same accessories twice. */
          self.selected = [];
          self.refreshAddons(false);
          self.renderBuild(false);
          S.announce(strings.added);
          S.Cart.open(qs('[data-atc]', self));
        }).catch(function (err) {
          self.busy = false;
          buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
          if (errorBox) { errorBox.textContent = err.message; errorBox.hidden = false; }
          S.announce(err.message);
        });
      }

      onBackInStock(button) {
        var S = window.Strolee;
        var wrap = button.closest('[data-bis]');
        var input = qs('[data-bis-email]', wrap);
        var box = qs('[data-bis-message]', wrap);
        var email = (input.value || '').trim();
        if (!S.validEmail(email)) {
          input.setAttribute('aria-invalid', 'true');
          S.showMessage(box, 'error', window.theme.strings.emailInvalid);
          input.focus();
          return;
        }
        input.removeAttribute('aria-invalid');
        button.setAttribute('aria-busy', 'true');
        S.klaviyoBackInStock(email, this.variant.id).then(function () {
          button.removeAttribute('aria-busy');
          S.showMessage(box, 'success', wrap.getAttribute('data-success') || 'Got it. We will email you when it is back.');
        }).catch(function () {
          button.removeAttribute('aria-busy');
          S.showMessage(box, 'error', wrap.getAttribute('data-error') || 'Something went wrong. Please try again.');
        });
      }

      observeSticky() {
        var bar = this.sticky;
        var main = qs('[data-atc]', this);
        if (!bar || !main || !('IntersectionObserver' in window)) return;
        var root = document.documentElement;
        /* When the button lives at the bottom of the builder, the bar also shows while the button is still
           below the fold (once the shopper has scrolled a screen), so there is always a way to buy in reach. */
        var inBuilder = !!main.closest('[data-always]');
        var inView = true;
        bar.hidden = false;
        var apply = function () {
          var show = !inView && (main.getBoundingClientRect().top < 0 || (inBuilder && window.scrollY > window.innerHeight * 0.75));
          bar.classList.toggle('is-visible', show);
          if (show) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
          root.style.setProperty('--sticky-atc-h', show ? bar.offsetHeight + 'px' : '0px');
        };
        var observer = new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          apply();
        }, { threshold: 0 });
        observer.observe(main);
        if (inBuilder) {
          var ticking = false;
          window.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () { ticking = false; apply(); });
          }, { passive: true });
        }
      }
    });
  }
})();
